function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import React, { useState, useEffect } from 'react';
import { Paper, Skeleton, useUser, KpiCards, QuickActions, CreditStatusChart, LatePaymentsBuckets, GivenAmountsChart, OutstandingChart, ExpectedPrincipalChart } from 'components';
import { getDashboardSummary } from 'services';
import { showApiError } from 'utils';
import { jsx as ___EmotionJSX } from "@emotion/react";

var pageContainer = function pageContainer(theme) {
  return {
    padding: '2em 2.4em',
    '@media (max-width: 786px)': {
      padding: '1.2em'
    },
    color: theme.gray700
  };
};

var welcomeBar = function welcomeBar(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '2em',
    '& .welcome-title': {
      fontSize: '2.2rem',
      fontWeight: 700,
      color: theme.gray800
    },
    '& .welcome-date': {
      fontSize: '1.3rem',
      color: theme.gray400
    }
  };
};

var actionsBar = function actionsBar(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    padding: '1em 1.4em',
    backgroundColor: theme.white,
    border: "1px solid ".concat(theme.gray100),
    boxShadow: theme.boxShadowLight,
    marginBottom: '1.6em'
  };
};

var chartsGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '1.6em',
  marginBottom: '1.6em',
  '@media (max-width: 992px)': {
    gridTemplateColumns: '1fr'
  }
};

var collectionsGrid = function collectionsGrid(theme) {
  return {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
    gap: '1em',
    '& .cs-card': {
      padding: '1em',
      backgroundColor: theme.gray50,
      border: "1px solid ".concat(theme.gray100)
    },
    '& .cs-label': {
      fontSize: '1.1rem',
      color: theme.gray400,
      fontWeight: 500,
      marginBottom: '0.4em'
    },
    '& .cs-value': {
      fontSize: '1.6rem',
      color: theme.gray800,
      fontWeight: 600
    }
  };
};

var skeletonCard = function skeletonCard(theme) {
  return {
    padding: '1.4em 1.6em',
    backgroundColor: theme.white,
    boxShadow: theme.boxShadowLight
  };
};

var SkeletonKpi = function SkeletonKpi() {
  return ___EmotionJSX("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
      gap: '1.2em'
    }
  }, [1, 2, 3, 4].map(function (i) {
    return ___EmotionJSX("div", {
      css: skeletonCard,
      key: i
    }, ___EmotionJSX(Skeleton, {
      width: 100,
      height: 12
    }), ___EmotionJSX(Skeleton, {
      width: 140,
      height: 28,
      margin: "0.6em 0 0 0"
    }), ___EmotionJSX(Skeleton, {
      width: 120,
      height: 14,
      margin: "0.4em 0 0 0"
    }));
  }));
};

var SkeletonChart = function SkeletonChart() {
  return ___EmotionJSX(Paper, {
    noPadding: true,
    padding: "1em"
  }, ___EmotionJSX(Skeleton, {
    width: 160,
    height: 16,
    margin: "0 0 1em 0"
  }), ___EmotionJSX(Skeleton, {
    height: 240
  }));
};

var Dashboard = function Dashboard() {
  var _userInfo$name$split$, _userInfo$name, _userInfo$name$split, _data$active_portfoli, _data$active_portfoli2;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo,
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _ref = roleAdditionalData !== null && roleAdditionalData !== void 0 ? roleAdditionalData : {},
      isAdminOrTenantOrOwnerOrManager = _ref.isAdminOrTenantOrOwnerOrManager,
      canIssueCredits = _ref.canIssueCredits,
      isPartnerOrPartnerManager = _ref.isPartnerOrPartnerManager;

  useEffect(function () {
    getDashboardSummary().then(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          res = _ref3[0],
          err = _ref3[1];

      if (err) showApiError(err);else setData(res);
    });
  }, []);
  var today = new Date().toLocaleDateString('bg-BG', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  var firstName = (_userInfo$name$split$ = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$name = userInfo.name) === null || _userInfo$name === void 0 ? void 0 : (_userInfo$name$split = _userInfo$name.split(' ')) === null || _userInfo$name$split === void 0 ? void 0 : _userInfo$name$split[0]) !== null && _userInfo$name$split$ !== void 0 ? _userInfo$name$split$ : '';
  var cur = (_data$active_portfoli = data === null || data === void 0 ? void 0 : (_data$active_portfoli2 = data.active_portfolio) === null || _data$active_portfoli2 === void 0 ? void 0 : _data$active_portfoli2.currency) !== null && _data$active_portfoli !== void 0 ? _data$active_portfoli : 'EUR';

  if (isPartnerOrPartnerManager) {
    return ___EmotionJSX("div", {
      css: pageContainer
    }, ___EmotionJSX("div", {
      css: welcomeBar
    }, ___EmotionJSX("h2", {
      className: "welcome-title"
    }, "\u0417\u0434\u0440\u0430\u0432\u0435\u0439\u0442\u0435, ", firstName), ___EmotionJSX("span", {
      className: "welcome-date"
    }, today)));
  }

  return ___EmotionJSX("div", {
    css: pageContainer
  }, ___EmotionJSX("div", {
    css: welcomeBar
  }, ___EmotionJSX("h2", {
    className: "welcome-title"
  }, "\u0417\u0434\u0440\u0430\u0432\u0435\u0439\u0442\u0435, ", firstName), ___EmotionJSX("span", {
    className: "welcome-date"
  }, today)), ___EmotionJSX("div", {
    style: {
      marginBottom: '1.6em'
    }
  }, data ? ___EmotionJSX(KpiCards, {
    data: data,
    showFunds: isAdminOrTenantOrOwnerOrManager,
    currency: cur
  }) : ___EmotionJSX(SkeletonKpi, null)), ___EmotionJSX("div", {
    css: actionsBar
  }, ___EmotionJSX(QuickActions, {
    canIssueCredits: canIssueCredits,
    isAdminOrTenantOrOwnerOrManager: isAdminOrTenantOrOwnerOrManager
  })), ___EmotionJSX("div", {
    css: chartsGrid
  }, data ? ___EmotionJSX(CreditStatusChart, {
    creditCounts: data.credit_counts
  }) : ___EmotionJSX(SkeletonChart, null), data ? ___EmotionJSX(LatePaymentsBuckets, {
    overdueSummary: data.overdue_summary,
    currency: cur
  }) : ___EmotionJSX(SkeletonChart, null)), isAdminOrTenantOrOwnerOrManager && ___EmotionJSX("div", {
    css: chartsGrid
  }, data ? ___EmotionJSX(GivenAmountsChart, {
    givenByMonth: data.given_by_month,
    currency: cur
  }) : ___EmotionJSX(SkeletonChart, null), data !== null && data !== void 0 && data.available_funds ? ___EmotionJSX(OutstandingChart, {
    fundsData: data.available_funds,
    currency: cur
  }) : ___EmotionJSX(SkeletonChart, null)), isAdminOrTenantOrOwnerOrManager && ___EmotionJSX("div", {
    css: chartsGrid
  }, ___EmotionJSX(ExpectedPrincipalChart, {
    currency: cur
  })), (data === null || data === void 0 ? void 0 : data.collections_this_month) && isAdminOrTenantOrOwnerOrManager && ___EmotionJSX(Paper, {
    header: "\u0421\u044A\u0431\u0438\u0440\u0430\u043D\u0435 \u0442\u043E\u0437\u0438 \u043C\u0435\u0441\u0435\u0446",
    margin: "0 0 1.6em 0"
  }, ___EmotionJSX("div", {
    css: collectionsGrid
  }, [{
    label: 'Главница',
    value: data.collections_this_month.principal
  }, {
    label: 'Лихва',
    value: data.collections_this_month.interest
  }, {
    label: 'Такси',
    value: data.collections_this_month.fees
  }, {
    label: 'Общо',
    value: data.collections_this_month.total
  }].map(function (item) {
    return ___EmotionJSX("div", {
      className: "cs-card",
      key: item.label
    }, ___EmotionJSX("p", {
      className: "cs-label"
    }, item.label), ___EmotionJSX("p", {
      className: "cs-value"
    }, Number(item.value).toFixed(2), " ", cur));
  }))));
};

export default Dashboard;